import * as Yup from "yup";
import LuhnCheckDigitUtil from "./LuhnCheckDigitUtil";

export function getStringRule(customText = "Input", required, min, max) {
    let yup = Yup.string();
    if (required === true) yup = yup.required(customText + " is required");
    if (min !== undefined) yup = yup.min(min, customText + " must be at least " + min + " characters");
    if (max !== undefined) yup = yup.max(max, customText + " must be at most " + max + " characters");
    return yup;
}

export function getNumericRule(customText = "Input", required, min, max) {

    let yup = Yup.string();
    let regex = /^\d+$(\.\d+)?/g;

    if (required === true) yup = yup.required(customText + " is required");
    if (min !== undefined) yup = yup.min(min, customText + " must be at least " + min + " characters");
    if (max !== undefined) yup = yup.max(max, customText + " must be at most " + max + " characters");

    yup = yup.test('number', customText + " must be numeric", function (value = '') {
        if (required === false && (value === '' || value.match(regex))) {
            return true;
        } else return !!(required === true && value.match(regex));
    });

    return yup;
}

export function getPostalCodeRule(customText = "Input", required) {

    let yup = Yup.string();
    let regex = /^\d+$(\.\d+)?/g;

    if (required === true) yup = yup.required(customText + " is required");
    yup = yup.min(4, customText + " must be at least 4 characters");
    yup = yup.max(4, customText + " must be at most 4 characters");

    yup = yup.test('number', customText + " must be numeric", function (value = '') {
        if (required === false && (value === '' || value.match(regex))) {
            return true;
        } else return !!(required === true && value.match(regex));
    });

    yup = yup.test('number-0000', customText + " cannot be 0000", function (value = '') {
        return (value !== "0000");
    });
    yup = yup.test('number-9999', customText + " cannot be 9999", function (value = '') {
        return (value !== "9999");
    });

    return yup;
}

export function getCurrencyAmountRule(customText = "Amount", required, decimalPlaces = 2, mustBeGreaterThanZero = true) {
    let yup = Yup.string()
        .matches(/^\S*$/, 'No spaces are allowed');
    if (required === true) yup = yup.required(customText + " is required");

    yup = yup.test('amount-negative', customText + " cannot be negative.", function (value = '') {
        let valueNum = parseFloat(value).toFixed(decimalPlaces);
        if (valueNum < 0) return false;
        return true;
    })
        .test('amount-test', customText + " must be a number.", function (value = '') {
            if (isNaN(value)) return false;
            return true;
        })
        .test('amount-point', customText + " cannot start with a '.'", function (value = '') {
            if (value.charAt(0) === '.') return false;
            return true;
        });

    if (mustBeGreaterThanZero === true)
        yup = yup.test('amount-zero', customText + " cannot be 0.", function (value = '') {
            if (value === '0') return false;
            return true;
        });

    return yup;
}

export function getInternationalCellphoneNumberRule(customText = "Cellphone Number", required) {

    let yup = Yup.string();
    let regex = /^((\+)?)([\s-.()]*\d{1}){8,13}$/;

    yup = yup.test('cellphone-number-start', customText + " must be a valid cellphone number", function (value) {
        if (required === false && (value.match(regex) || value === '')) {
            return true;
        } else return !!(required === true && value.match(regex));
    });

    if (required === true) yup = yup.required(customText + " is required");

    return yup;
}

export function getCellphoneNumberRule(customText = "Cellphone Number", required) {

    let yup = Yup.string();
    let regex = /^(\+27|27|0)[0-9]{9}$/;

    if (required === true) yup = yup.required(customText + " is required");

    yup = yup.test('cellphone-number-start', customText + " must be a valid South African cellphone number", function (value) {
        if (required === false && (value.match(regex) || value === '')) {
            return true;
        } else return !!(required === true && value.match(regex));
    });

    return yup;
}

export function getEmailAddressRule(customText = "Email Address", required) {
    let yup = Yup.string()
        .email('Not a valid Email Address');

    if (required === true) yup = yup.required(customText + " is required");

    return yup;
}


export function getIntegerRule(customText = "Input", required, mustBeGreaterThanZero = true) {
    let yup = Yup.string()
        .matches(/^\S*$/, 'No spaces are allowed');
    if (required === true) yup = yup.required(customText + " is required");

    yup = yup.test('amount-negative', customText + " cannot be negative.", function (value) {
        let valueNum = parseFloat(value);
        if (valueNum < 0) return false;
        return true;
    })
        .test('amount-test', customText + " must be a whole number.", function (value) {
            if (isNaN(value)) return false;
            if (value.indexOf(".") >= 0) return false;
            return true;
        });

    if (mustBeGreaterThanZero === true)
        yup = yup.test('amount-zero', customText + " cannot be 0.", function (value) {
            if (value === '0') return false;
            return true;
        });

    return yup;
}

export function getDecimalRule(customText = "Input", required, decimalPlaces = 2, mustBeGreaterThanZero = true) {

    let yup = Yup.string().matches(/^\S*$/, 'No spaces are allowed');

    if (required === true) yup = yup.required(customText + " is required");

    yup = yup.test('amount-point', customText + " cannot start with a '.'", function (value) {
        return value.charAt(0) !== '.';

    });

    yup = yup.test('amount-test', customText + " must be a number.", function (value) {
        return !isNaN(value);

    });

    yup = yup.test('amount-negative', customText + " cannot be negative.", function (value) {
        let valueNum = parseFloat(value).toFixed(decimalPlaces);
        return valueNum >= 0;

    });

    if (mustBeGreaterThanZero === true)
        yup = yup.test('amount-zero', customText + " cannot be 0.", function (value) {
            return value !== '0';

        });

    return yup;
}

export function getAlphaSpaceValidator(customText = "Input", required) {

    let yup = Yup.string();
    let regex = /^[a-zA-Z\s]+$/;

    if (required === true) yup = yup.required(customText + " is required");

    yup = yup.test('alpha-space-test', customText + " must contain only alphabetic characters or spaces", function (value) {
        if (required === false && (value.match(regex) || value === '')) {
            return true;
        } else return !!(required === true && value.match(regex));
    });

    return yup;
}

export function getAlphaNumericValidator(customText = "Input", required) {

    let yup = Yup.string();
    let regex = /^[a-zA-Z0-9]+$/;

    yup = yup.test('alpha-space-test', customText + " must contain only alphabetic and numeric characters", function (value) {
        if (required === false && (value.match(regex) || value === '')) {
            return true;
        } else return !!(required === true && value.match(regex));
    });

    if (required === true) yup = yup.required(customText + " is required");

    return yup;
}

export function getDOBValidator(customText = "Input", required) {

    let yup = Yup.string();

    if (required === true) yup = yup.required(customText + " is required");

    yup = yup.test(
        "dob",
        "You must be 18 years or older to register",
        value => {
            if (value) {
                let birthday = +new Date(value);
                let divisor = 24 * 3600 * 365.25 * 1000;
                let age = ((Date.now() - birthday) / (divisor));
                return age >= 18;
            } else return false;
        });

    return yup;
}

export function getIdExpiryDateValidator(customText = "Id Expiry Date", required) {

    let yup = Yup.string();

    if (required === true) yup = yup.required(customText + " is required");

    yup = yup.test(
        "idExpiryDate",
        customText + " must be greater than today",
        value => {
            if (value) {
                return +new Date(value) > Date.now();
            } else return false;
        });

    return yup;
}

export function getSAIDNumberValidator(customText = "Input", required, gender, dob) {

    let yup = Yup.string();

    if (required === true) yup = yup.required(customText + " is required");

    yup = yup.matches(/^[a-zA-Z0-9]+$/, 'No spaces are allowed');

    yup = yup.test(
        "sa_id",
        "A valid Id Number must be entered",
        (value) => {
            let tempDob = dob;
            tempDob = tempDob.replace("-", "");
            tempDob = tempDob.replace("-", "");

            let tempGender = gender;
            tempGender = tempGender.toLowerCase();

            if (tempDob.length === 8 && value.length === 13) {
                if (value.substring(0, 6) === tempDob.substring(2, 8)) {
                    if (tempGender === "male") {
                        let validGender = value.charAt(6) >= 5;
                        if (validGender)
                            return LuhnCheckDigitUtil.validate(value);
                        else
                            return false;
                    } else {
                        let validGender = value.charAt(6) < 5;
                        if (validGender)
                            return LuhnCheckDigitUtil.validate(value);
                        else
                            return false;
                    }
                }
            }
            return false;
        });
    return yup;
}

export function getSAIDNumberValidatorBeforeDobGender(customText = "Input", required) {

    let yup = Yup.string();

    if (required === true) yup = yup.required(customText + " is required");

    yup = yup.matches(/^[a-zA-Z0-9]+$/, 'No spaces are allowed');

    yup = yup.test(
        "sa_id",
        "A valid " + customText + " must be entered",
        (value) => {
            return LuhnCheckDigitUtil.validate(value);
        });
    return yup;
}

export function getGenderValidator(customText = "", required) {
    let yup = Yup.string();

    if (required === true) yup = yup.required(customText + " is required");

    yup = yup.test(
        "gender",
        "Your gender can only be Male or Female",
        (value) => {
            if (value !== 'Male' && value !== 'Female') {
                return false;
            }
            return true;
        });
    return yup;
}

export function getNationalityRule(customText = "Input", required) {
    let yup = Yup.string();

    if (required === true) yup = yup.required(customText + " is required");

    yup = yup.test(
        "nationality",
        "Your nationality cannot be South African if your id type is not a South African ID",
        (value) => {
            if (value === 'South Africa (ZAF)') {
                return false;
            }
            return true;
        });

    return yup;
}
